import React, { useCallback, useEffect, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Icon, Menu } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { findParentNode } from '../../../helpers/menuTree/menuTree';
import MenuItemContainer from './MenuItemContainer';

import EfesLogo from '../../../img/efesLogoDarkWithText.png';
import CloseSvg from '../../../img/close.svg';

import styles from '../responsiveContainer.module.scss';

const EfesSideBarMenu = ({ routeTree, handleNavigation, handleClose }) => {
  const { t } = useTranslation();
  const [activeItem, setActiveItem] = useState(routeTree);
  const [out, setOut] = useState(false);

  useEffect(() => {
    setActiveItem(routeTree);
  }, [routeTree]);

  const navigate = useCallback(
    (item) => {
      setOut(false);
      if (item.children) {
        setActiveItem(item);
      } else {
        handleNavigation(item);
      }
    },
    [handleNavigation],
  );

  const navigateBack = useCallback(
    (item) => {
      const parentNode = findParentNode(routeTree, item);
      setOut(true);
      setActiveItem(parentNode);
    },
    [routeTree],
  );

  const navigateHome = useCallback(() => {
    handleNavigation({ path: '/' });
  }, [handleNavigation]);

  return (
    <div className={styles.mobileSidebarMenuWrapper}>
      <div className={styles.mobileSidebarMenuHeader}>
        <img src={EfesLogo} alt="logo" />
        <div role="button" tabIndex="0" onClick={handleClose}>
          <img src={CloseSvg} alt="close" className={styles.closeIcon} />
        </div>
      </div>

      {activeItem && activeItem.children && (
        <Menu vertical className={styles.mobileSidebarMenu}>
          <Menu.Item
            className={styles.navigateHome}
            as="a"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigateHome();
            }}
          >
            <Icon name="home" className={styles.homeIcon} />
            {t('navigateHome')}
          </Menu.Item>
          <TransitionGroup className={out ? styles.navigationOut : styles.navigationIn}>
            <CSSTransition
              in
              timeout={{
                appear: 500,
                enter: 300,
                exit: 0,
              }}
              classNames="items_container"
              key={activeItem.title}
            >
              <MenuItemContainer
                node={activeItem}
                onNavigate={navigate}
                onNavigateBack={navigateBack}
                handleClose={handleClose}
              />
            </CSSTransition>
          </TransitionGroup>
        </Menu>
      )}
    </div>
  );
};

EfesSideBarMenu.propTypes = {
  handleNavigation: PropTypes.func,
  handleClose: PropTypes.func,
  routeTree: PropTypes.shape({
    children: PropTypes.arrayOf(
      PropTypes.shape({
        header: PropTypes.string,
        icon: PropTypes.element,
        links: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            path: PropTypes.string,
          }),
        ),
      }),
    ),
  }),
};

EfesSideBarMenu.defaultProps = {
  handleClose: () => {},
  handleNavigation: () => {},
  routeTree: { children: [] },
};

export default EfesSideBarMenu;
